import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { Grid, Card, CardHeader, FormGroup, CardContent, CardActions } from '@material-ui/core';
import { useStyles } from 'components/Shared/DynamicForm';

export default () => {
  const classes = useStyles();
  return (
    <Grid container justify='center'>
      <Grid item xs={12} style={{ padding: 24 }}>
        <Card raised>
          <CardHeader className={classes.cardHeader}>
            <Skeleton height={60} width={60}/>
          </CardHeader>
          <CardContent>
            <Skeleton height={60}/>
            <Skeleton height={60}/>
            <Skeleton height={60}/>
            <Skeleton height={60}/>
            <Skeleton height={60}/>
          </CardContent>
          <CardActions>
            <FormGroup className={classes.formField}>
              <Skeleton height={60} width={60}/>
            </FormGroup>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  )
};

